import React, { useState, useCallback, useMemo } from 'react'
import { Icon, Input } from '@roo/roo'
import styles from './index.module.less'
import { i18nClient, useTranslation } from '@sailor/i18n-web'
import PswIcon from '@/pages/password/components/PswIcon'

interface PasswordRule {
  key: string
  label: string
  validator: (password: string) => boolean
}

interface PasswordInputProps {
  value?: string
  onChange?: (value: string) => void
  placeholder?: string
  className?: string
}

// 密码规则定义
export const passwordRules: PasswordRule[] =  [
  {
    key: 'length',
    label: i18nClient.getText('e_pc_min_8_chars', '至少8个字符'),
    validator: (password: string) => password?.length >=   8,
  },
  {
    key: 'uppercase',
    label: i18nClient.getText('e_pc_include_uppercase', '至少包含一个大写字母'),
    validator: (password: string) => /[A-Z]/.test(password),
  },
  {
    key: 'lowercase',
    label: i18nClient.getText('e_pc_include_lowercase', '至少包含一个小写字母'),
    validator: (password: string) => /[a-z]/.test(password),
  },
  {
    key: 'number',
    label: i18nClient.getText('e_pc_include_number', '至少包含一个数字'),
    validator: (password: string) => /\d/.test(password),
  },
  {
    key: 'special',
    label: i18nClient.getText('e_pc_include_special_char', '至少包含一个特殊字符(!@#$%^&*)'),
    validator: (password: string) => /[!@#$%^&*]/.test(password),
  },
]

export const getPswError = (password: string) => passwordRules.find(rule => !rule.validator(password))?.label

const PasswordInput: React.FC<PasswordInputProps> = ({
  value = '',
  onChange,
  className,
}) => {
  const { t } = useTranslation()

  // 处理输入变化
  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value?.trim()
    onChange?.(newValue)
  }, [onChange])

  // 检查规则是否通过
  const getRuleStatus = useCallback((rule: PasswordRule) => rule.validator(value), [value])

  return (
    <div className={`${styles.passwordInput} ${className || ''}`}>
      <Input
        value={value}
        onChange={handleChange}
        placeholder={t('e_pc_enter_new_password', '请输入新密码')}
        className={styles.input}
        type="password"
        prefix={<PswIcon />}
      />

      <div className={styles.rulesContainer}>
        {passwordRules.map(rule => {
          const isValid = getRuleStatus(rule)
          return (
            <div
              key={rule.key}
              className={`${styles.rule} ${isValid ? styles.valid : styles.invalid}`}
            >
              <span className={styles.ruleIcon}>
                {isValid ? '✓' : '○'}
              </span>
              <span className={styles.ruleText}>{rule.label}</span>
            </div>
          )
        })}
      </div>

    </div>
  )
}

export default PasswordInput